import { useTranslation, useLabRequisitionList } from "hhn-commons";
import { IGroupInfo } from "@home-health-notify/domain";
import {
  EmptyListHelpText,
  LabRequisitionsContainer,
  LabRequisitionsTitleContainer,
} from "./LabRequisition.style";
import LabRequisitionListItem from "./LabRequisitionListItem";
import { ILabRequisitionData } from "@home-health-notify/domain";
import { ScrollableList } from "../../../common/scrollableList/ScrollableList";
import { ChatInfoPanelTitle } from "../../ChatInfo.style";
import { Loader } from "./LabRequisitionListItem.style";

type LabRequisitionsType = {
  groupInfo: IGroupInfo;
};

export default function LabRequisitions({ groupInfo }: LabRequisitionsType) {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "labRequisition" });

  const { isLoading, labRequisitions } = useLabRequisitionList(groupInfo);

  return (
    <LabRequisitionsContainer data-testid="lab-requisition-list">
      <LabRequisitionsTitleContainer>
        <ChatInfoPanelTitle>{tNs("labRequisitions")}</ChatInfoPanelTitle>
      </LabRequisitionsTitleContainer>
      {isLoading && <Loader></Loader>}
      {labRequisitions && labRequisitions.length === 0 && (
        <EmptyListHelpText>
          {tNs("noLabRequisitionsAvailable")}
        </EmptyListHelpText>
      )}
      {groupInfo && labRequisitions && labRequisitions.length > 0 && (
        <ScrollableList
          totalCount={labRequisitions.length}
          data={labRequisitions}
          itemContent={(index, requisition: ILabRequisitionData) => (
            <LabRequisitionListItem
              key={requisition.id + index}
              requisition={requisition}
              groupInfo={groupInfo}
            />
          )}
        />
      )}
    </LabRequisitionsContainer>
  );
}
